import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { EventBus } from '@vtblife/event-bus';
import React from 'react';
import { useEventSubscription } from '../../utils/use-event-subscription';
import { Quiz } from '../../components/quiz/quiz';
var eventBus = EventBus.getInstance();
export var openQuiz = function openQuiz(data) {
  var event = {
    category: 'simple',
    type: 'event:showQuiz',
    data: data
  };
  eventBus.publish(event);
};
/** Слушает событие event:showQuiz и показывает квиз */
export var OpenQuizModal = function OpenQuizModal(_ref) {
  var environment = _ref.environment;
  var props = useEventSubscription('event:showQuiz');
  var _ref2 = (props === null || props === void 0 ? void 0 : props.eventData) || {},
    id = _ref2.id;
  return id ? React.createElement(Quiz, _objectSpread(_objectSpread({}, props.eventData), {}, {
    id: id,
    isOpen: props.isOpen,
    onClose: props.onClose,
    environment: environment
  })) : null;
};